module.exports = __webpack_public_path__ + "static/media/seoul-2033.900c0fff.png";